class SsoPasswordReset extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.clicked = false
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)
    this.listeners.add(this.els.link.element, 'click', this.handleClick)
  }

  async handleClick (event) {
    event.preventDefault()

    if (this.clicked) return
    this.clicked = true

    this.externalEls.modal.element.classList.add('prm-PasswordReset-active')

    const response = await fetch(
      `https://${window.theme.sso.tenantUrl}/dbconnections/change_password`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id: window.theme.sso.clientId,
          email: this.dataset.email,
          connection: 'Username-Password-Authentication',
        }),
      },
    )

    await response.text()
  }
}

if (!customElements.get('sso-password-reset')) {
  customElements.define('sso-password-reset', SsoPasswordReset)
}
